<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">新闻中心</div>
      <div class="t-t2box">
        <div class="t-t2">聚焦营销新动态 发掘行业新商机</div>
      </div>
    </div>

    <div class="box1">
      <!-- 左边 -->
      <div class="boxleft">
        <!-- 左边标题 -->
        <div class="title">
          <div class="t1">2022年百度渠道生态合作部展示类分销商引入告知函</div>
          <div class="t2">2022-06-15</div>
        </div>

        <!-- 左边内容 -->
        <div class="textbox">
          分布式存储是相对干集中式存储来说的，在介绍分布式存储之前，我们先看看什么是集中式存储。不久之前，企业级的存储设备都 是集中式存储。所谓集中式存储，从概念上可以看出来是具有集中的，也就是整个存储是集中在一个系统中的。但集中式存储并不是
          一个单独的设备，是集中在一套系统当中的多个设备。以EMX公司的存储为例，整个存储系统可能需要几个机柜来存放。<br /><br />
          在集中式存储中通常包含一个机头，这个是存储系统中最为核心的部件。通常在机头中有包含两个控制器，这两个控制器实现互备 的作用，避免硬件故障导致整个存储系统的不可用。在该机头中通常包含前端端口和后端端口，前端端口用户为服务器提供存储服务
          而后端端口用干扩充存储系统的容量。通过后端端口机头可以连接更多的存储设备，从而形成一个非常大的存储资源池。<br /><br />
          机头中是整个存储系统的核心部件，整个存储系统的高级功能都在其中实现。控制器中的软件实现对磁盘的管理，将磁盘抽象化 为存储资源池，然后划分为LUN提供给服务器使用。这里的LUN其实就是在服务器上看到的磁盘。当然，一些集中式存储本身也是文
          件服务器，可以为服务器提供共享文件服务。无论如何，从上面我们可以看出集中式存储最大的特点是有一个统一的入口，所有数据者 要经过这个入口，这个入口就是存储系统的机头。<br /><br />
          分布式存储是一个大的概念，其包含的种类繁多，除了传统意义上的分布式文件系统，分布式块存储和分布式对象存储外，还包括 分布式数据库和分布式缓存等。本文局限在分布式文件系统等传统意义上的存储架构，对于数据库等不做介绍<br /><br />
          分布式存储最早是由谷歌提出的，其目的是通过价的服务器来提供使用与大规模，高并发场景下的Web访问问题。如图3是谷歌
          分布式存储(HDFS)的简化的模型。在该系统的整个架构中将服务器分为两种类型，一种名为namenode，这种类型的节点负责管理管理数据(元数据)，另外一种名为datanode,这种类型的服务器负责实际数据的管理。
        </div>

        <!-- 左边底部选择栏 -->

        <div class="btm">
          <div class="btm-left">上一页： 新厂精益布局规划</div>
          <div class="btm-right">下一页： 新厂精益布局规划</div>
        </div>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <div class="topp">为您推荐</div>

        <div class="item2">
          <img src="@/image/more/news/tu4@2x.png" alt="" />

          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item2">
          <img src="@/image/more/news/tu4@2x.png" alt="" />

          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewcuxxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}

// 顶部
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/more/banner@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.box1 {
  width: 72%;
  height: 1520px;
  display: flex;
  margin: 60px auto;
  // background-color: #fafafa;
  padding-left: 180px;

  .boxleft {
    width: 860px;
    height: 100%;
    padding-top: 3px;

    margin-right: 60px;

    .title {
      margin: 0 auto;
      width: 860px;
      text-align: center;
      .t1 {
        font-size: 30px;
        margin-bottom: 25px;
      }
      .t2 {
        color: #999999;
      }
    }

    .textbox {
      margin-top: 25px;
      padding-top: 25px;
      border-top: 2px solid #fafafa;
      color: #333333;
      line-height: 30px;
      letter-spacing: 1px;
    }

    .btm {
      margin-top: 150px;
      padding: 20px 10px;
      border-top: 2px solid #fafafa;
      display: flex;
      justify-content: space-between;
    }
    .btm-left:hover,
    .btm-right:hover {
      color: #4581fb;
    }
  }

  .boxright {
    margin-top: 5px;
    box-shadow: 0px 1px 10px 10px #fafafa;
    // box-shadow-right:
    width: 345px;
    height: 89%;
    box-sizing: border-box;
    padding-left: 22px;
    border-radius: 12px;
    .topp {
      font-size: 22px;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .item2 {
      position: relative;
      height: 310px;
      margin-bottom: 20px;

      .le2 {
        // top: 25px;
        position: absolute;
        width: 285px;
        height: 112px;
        border-bottom: 2px solid #fafafa;
        .title {
          color: #333333;

          letter-spacing: 1px;
          font-size: 16px;
        }
        .time {
          position: absolute;
          bottom: 20px;
          color: #999999;
        }
      }

      img {
        width: 300px;
        height: 180px;
        margin-bottom: 15px;
      }
    }

    .item3 {
      position: relative;
      height: 112px;
      margin-bottom: 30px;

      .le2 {
        // top: 25px;
        position: absolute;
        width: 285px;
        height: 112px;
        border-bottom: 2px solid #fafafa;
        .title {
          color: #333333;

          letter-spacing: 1px;
          font-size: 16px;
        }
        .time {
          position: absolute;
          bottom: 20px;
          color: #999999;
        }
      }
    }
  }
}
</style>
